import { render, staticRenderFns } from "./THGCO2EquivalentsList.vue?vue&type=template&id=cda9b748"
import script from "./THGCO2EquivalentsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCO2EquivalentsList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports